import type { FrameApplyContext } from "./companion-frame-reducer";

type TtsStore = FrameApplyContext["ttsStore"];
type TtsState = ReturnType<TtsStore["getState"]>;

const silentTtsState: TtsState = {
  speakingState: null,
  isActive: () => false,
  speak: () => undefined,
  speakStreamingReply: () => undefined,
  speakAcknowledgement: () => undefined,
  speakLiveTalkAcknowledgement: () => undefined,
  cancelAcknowledgement: () => undefined,
  cancelLiveTalkAcknowledgements: () => undefined,
  speakFinalReply: () => undefined,
  cancel: () => undefined,
  cancelPresentationSpeech: () => undefined,
  hasPendingPresentationSpeech: () => false,
  speakLatestReply: () => undefined,
  clearReplyDedup: () => undefined,
  resumeAnsweredTurn: () => undefined,
};

export const silentTtsStore = {
  getState: () => silentTtsState,
} as TtsStore;
